import React, { Component } from 'react';
import growTypes from './proptypes';

const withGrow = WrappedComponent => {
  return class MapComponent extends Component {
    static contextTypes = growTypes;

    render() {
      const { data, actions } = this.context;

      return <WrappedComponent {...this.props} grow={{ data, actions }} />;
    }
  };
};

export default withGrow;



// WEBPACK FOOTER //
// ./src/hoc/grow/withGrow.js